/** sessionStorage key for post-login Job Match Score hydration (public preview funnel). */
export const MATCH_PREVIEW_CONTINUE_STORAGE_KEY = "matchPreviewContinue";

/**
 * Persist preview context before redirecting to sign-in / sign-up.
 * @param {{
 *   resumeUrl: string,
 *   resumeName?: string,
 *   jobUrl?: string,
 *   jobDescription?: string,
 *   activeTab: 'url'|'description',
 *   rawResponse?: object
 * }} data - optional `rawResponse`: full Job Match API body after a successful preview scan
 *   (restored on /job-match-score and saved to history). If sessionStorage quota is exceeded,
 *   a second attempt is made without `rawResponse`.
 */
export function persistMatchPreviewHandoff(data) {
  try {
    sessionStorage.setItem(
      MATCH_PREVIEW_CONTINUE_STORAGE_KEY,
      JSON.stringify(data),
    );
  } catch (e) {
    if (data && data.rawResponse != null) {
      try {
        const { rawResponse: _omit, ...rest } = data;
        sessionStorage.setItem(
          MATCH_PREVIEW_CONTINUE_STORAGE_KEY,
          JSON.stringify(rest),
        );
      } catch (e2) {
        // storage full / private mode — handoff best-effort only
      }
    }
  }
}

/** Same shape as ProtectedRoute: send user to full Job Match Score after auth. */
export function setPageToVisitJobMatchScore() {
  try {
    const accountType = localStorage.getItem("accountType");
    sessionStorage.setItem(
      "pageToVisit",
      JSON.stringify({
        accountType: accountType,
        path: "/job-match-score",
      }),
    );
  } catch (e) {
    // no-op
  }
}
